import React, { useEffect, useState, useRef } from "react";
import { useTabs } from "../hooks/useTabs";
import Space from "../ui/Space";
import Label from "../ui/Label";
import Input from "../ui/Input";
import Status from "../ui/Status";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { InfoIcon } from "../utils/Icons";
import Button from "../ui/Button";

export default function PrintInvoiceHistory(props) {
    const { controller = "", callback = () => { }, route = "" } = props;

    const defaultTabs = [
        { label: "From:", key: "from", value: "" },
        { label: "To:", key: "to", value: "" },
        { label: "Only for Shipto:", key: "ship_to", value: "" },
        { label: "Only transactions with header PO:", key: "header_po", value: "" },
        { label: "Include transaction types:", key: "types", value: "" },
    ]

    const {
        tabs, setTabs, index, setIndex, update, getVal, editProps, next, prev, refs
    } = useTabs(defaultTabs, "from");

    useEffect(() => {
        const el = refs?.current?.[index];
        if (el && typeof el.focus === 'function') {
            el.focus();
        }
        const actions = [
            { key: KBD.TAB, action: next },
            { key: KBD.SHIFT_TAB, action: prev },
            { key: KBD.ARROW_DOWN, action: next },
            { key: KBD.ARROW_UP, action: prev },
            { key: KBD.ESCAPE, action: () => { callback(false) } },
        ]
        const cleanup = listen(controller, route, actions, false, [KBD.ENTER, KBD.ESCAPE, KBD.TAB, KBD.SHIFT_TAB, KBD.ARROW_DOWN, KBD.ARROW_UP]);
        return cleanup;
    }, [index])

    return (
        <div style={{ "width": "500px"}}>
            <div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" />
            <Space height={25} size={10}>
                <Label className={(index === "from") ? "selected" : ""} width={230}>From:</Label>
                <Input autoselect maxLength={50} {...editProps("from")} className={(index !== "from") ? "dim" : ""} placeholder="" width={150} />
            </Space>
            <div className="shim" /><div className="shim" />
            <Space height={25} size={10}>
                <Label className={(index === "to") ? "selected" : ""} width={230}>To:</Label>
                <Input autoselect maxLength={50} {...editProps("to")} className={(index !== "to") ? "dim" : ""} placeholder="" width={150} />
            </Space>
            <div className="shim" /><div className="shim" />
            <Space height={25} size={10}>
                <Label className={(index === "ship_to") ? "selected" : ""} width={230}>Only for Shipto:</Label>
                <Input autoselect maxLength={50} {...editProps("ship_to")} className={(index !== "ship_to") ? "dim" : ""} placeholder="" width={150} />
            </Space>
            <div className="shim" /><div className="shim" />
            <Space height={25} size={10}>
                <Label className={(index === "header_po") ? "selected" : ""} width={230}>Only transactions with header PO:</Label>
                <Input autoselect maxLength={50} {...editProps("header_po")} className={(index !== "header_po") ? "dim" : ""} placeholder="" width={150} />
            </Space>
            <div className="shim" /><div className="shim" />
            <Space height={25} size={10}>
                <Label className={(index === "types") ? "selected" : ""} width={230}>Include transaction types:</Label>
                <Input autoselect maxLength={50} {...editProps("types")} className={(index !== "types") ? "dim" : ""} placeholder="" width={150} />
            </Space>
            <Space height={50} size={10}>
                <Button type="primary" style={{"marginLeft": "240px"}}>Generate Invoice [pgdn]</Button>
            </Space>
            <div className="shim" /><div className="shim" />
            <Status><InfoIcon />[enter] to Change option. [pgdn] to generate report. </Status>
        </div>
    )
}